export default "__VITE_ASSET__DcWWS78u__"